import { render, staticRenderFns } from "./FullJournalPreviewContent.vue?vue&type=template&id=ff49b49a&scoped=true"
import script from "./FullJournalPreviewContent.vue?vue&type=script&lang=js"
export * from "./FullJournalPreviewContent.vue?vue&type=script&lang=js"
import style0 from "./FullJournalPreviewContent.vue?vue&type=style&index=0&id=ff49b49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff49b49a",
  null
  
)

export default component.exports